module.exports = __webpack_public_path__ + "static/img/map.fa199ca.png";